/** @jsxImportSource @emotion/react */

import { Card, Icon, Typography, useTheme } from '@quickbit/qb-design-system';

export const OrderTicker = ({
  value,
  title,
  isCurrency,
  isPercentage,
}: {
  value: number;
  title: string;
  isCurrency?: boolean;
  isPercentage?: boolean;
}) => {
  const { spacing } = useTheme();

  const valueString = value.toFixed(isCurrency || isPercentage ? 2 : 0);

  const titleWidth = title.length * 10;
  const valueWidth = valueString.length * 24; // Adjust the multiplier as needed

  return (
    <div>
      <Card>
        <div
          css={{
            width: `${titleWidth > valueWidth ? titleWidth : valueWidth}px`,
          }}
        >
          <Typography variant="subtitle">{title}</Typography>
          <div
            css={{ display: 'flex', alignItems: 'center', gap: spacing.xxxs }}
          >
            {isCurrency && <Icon name="EUR" />}
            <Typography variant="heading1">{valueString}</Typography>
            {isPercentage && <Typography>%</Typography>}
          </div>
        </div>
      </Card>
    </div>
  );
};
